export enum Locale {
  SL = "SL",
  EN = "EN",
}
